import React, { Component } from 'react';
import {observer} from "mobx-react"
import EntreeStore from "../EntreeStore"
import ReactAudioPlayer from 'react-audio-player';
import axios from "axios"
import { ReactMic } from 'react-mic';
import ImageLiminaires from "./ImageLiminaires"
import 'react-html5-camera-photo/build/css/index.css';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import Recorder from "../Recorder"


@observer
export default class RemarquesLiminaires extends Component {
  constructor(props) {
    super(props);
    this.loadRecords = this.loadRecords.bind(this)
    this.textAudioChange = this.textAudioChange.bind(this)
    this.transcrire = this.transcrire.bind(this)
    this.deleteAudio = this.deleteAudio.bind(this)
    this.state = {
      isLoading: false,
      savedRecords: [],
      blobs: [],
      images: [],
      imagesData: [],
      texteInitial: "",
      transcription_encours: true
    };
    this.loadRecords()
  }
  loadRecords(){
    axios.post("/api/v1/experts/app/entree/getRemarquesLiminaires",{id: EntreeStore.rdv.id}).then((data)=>{
      this.setState({savedRecords: data.data.audios,
        texteInitial: data.data.text,
        transcription_encours: data.data.transcription})
    })
  }
  deleteAudio(e){
    e.preventDefault()
    let id= e.target.dataset.audio
    axios.post("/api/v1/experts/app/entree/deleteAudioLiminaire",{id: EntreeStore.rdv.id,audio: id}).then((data)=>{
      this.loadRecords()
    })
  }
  transcrire(e){
    e.preventDefault()
    axios.post("/api/v1/experts/app/entree/transcrireLiminaire",{id: EntreeStore.rdv.id}).then((data)=>{
      this.loadRecords()
    })
  }

  textAudioChange(e){
      axios.post("/api/v1/experts/app/entree/updateTextLiminaire",{
      id: EntreeStore.rdv.id,
      txt: e
    }).then((data)=>{
      console.log("sauvé")
    })
  }
  render() {

    return (
      <React.Fragment>
        <h1 className="center">Remarques liminaires</h1>
        <div className="row">
          <div className="col s4">
          <div className="row">

          </div>
          <div className="row">
          <Recorder
           endpoint="/api/v1/experts/app/entree/uploadRemarqueLiminaire"
          data={{id: EntreeStore.rdv.id}}
          callback={this.loadRecords}

            />
          </div>
          <div className="diviser"></div>
          <p>Audios sauvés</p>
          <table>
              <tbody>
              <tr>
                <th></th>
                <th></th>
              </tr>
              </tbody>
              <tbody>
              {this.state.savedRecords.map((audio,index) => (
                <tr key={audio.id}>
                  <td><audio preload="auto" src={audio.url} controls /></td>
                  <td><a href="" onClick={this.deleteAudio} data-audio={audio.id} ><i data-audio={audio.id} className="material-icons red-text">delete</i></a></td>
                </tr>
              ))}
              </tbody>
            </table>
            </div>
            <div className="col s8">
              {this.state.transcription_encours ? (
              <a href="" className="btn col s4 offset-s1 disabled"><i className="material-icons left">cached</i>Transcription.</a>
              ) : (
              <a className="btn col s6 offset-s1 " onClick={this.transcrire} ><i className="material-icons left">edit</i>Transcrire</a>
              )}
            {true ? (
                  <div>
                    <h1 className="center">Entrez ici le script de l'audio</h1>
                    <SunEditor setContents={this.state.texteInitial} onChange={this.textAudioChange}
            setOptions={
                 {
            height: 500
                  }}/>

                  </div>
                  ) : (
                    <div></div>
                  )}
            </div>
          </div>
      </React.Fragment>
    );
  }
}
